/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Allocatable_SubtitleInputs */

const en_admin_resources_allocatable_subtitle = /** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rented exclusively to a member or team`)
};

const de_admin_resources_allocatable_subtitle = /** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exklusiv an ein Mitglied oder Team vermietet`)
};

const es_admin_resources_allocatable_subtitle = /** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquilado exclusivamente a un miembro o un equipo`)
};

const fr_admin_resources_allocatable_subtitle = /** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loué exclusivement à un membre ou une équipe`)
};

const nl_admin_resources_allocatable_subtitle = /** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusief verhuurd aan een lid of team`)
};

/** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */
const it_admin_resources_allocatable_subtitle = en_admin_resources_allocatable_subtitle;

/** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */
const pt_br2_admin_resources_allocatable_subtitle = en_admin_resources_allocatable_subtitle;

/** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */
const pl_admin_resources_allocatable_subtitle = en_admin_resources_allocatable_subtitle;

/** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */
const hu_admin_resources_allocatable_subtitle = en_admin_resources_allocatable_subtitle;

/** @type {(inputs: Admin_Resources_Allocatable_SubtitleInputs) => LocalizedString} */
const ro_admin_resources_allocatable_subtitle = en_admin_resources_allocatable_subtitle;

/**
* | output |
* | --- |
* | "Rented exclusively to a member or team" |
*
* @param {Admin_Resources_Allocatable_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_allocatable_subtitle = /** @type {((inputs?: Admin_Resources_Allocatable_SubtitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Allocatable_SubtitleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_allocatable_subtitle(inputs)
	if (locale === "de") return de_admin_resources_allocatable_subtitle(inputs)
	if (locale === "es") return es_admin_resources_allocatable_subtitle(inputs)
	if (locale === "fr") return fr_admin_resources_allocatable_subtitle(inputs)
	if (locale === "nl") return nl_admin_resources_allocatable_subtitle(inputs)
	if (locale === "it") return it_admin_resources_allocatable_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_allocatable_subtitle(inputs)
	if (locale === "pl") return pl_admin_resources_allocatable_subtitle(inputs)
	if (locale === "hu") return hu_admin_resources_allocatable_subtitle(inputs)
	return ro_admin_resources_allocatable_subtitle(inputs)
});
export { admin_resources_allocatable_subtitle as "admin.resources.allocatable_subtitle" }